import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ParallaxProvider } from 'react-scroll-parallax';
import { ThemeProvider } from '@material-ui/styles';
import { theme } from './Theme';

ReactDOM.render(
    <ParallaxProvider>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </ParallaxProvider>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
